/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EventInputs */

const th_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการแข่งขัน`)
};

const en_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const ja_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会`)
};

const zh_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛事`)
};

const es_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const pt_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const id_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const fr_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement`)
};

const tl_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const vi_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự kiện`)
};

const ko_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트`)
};

const de_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const ru_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие`)
};

const tr_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik`)
};

const it_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const pl_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenie`)
};

const uk_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подія`)
};

const hi_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन`)
};

const ar_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفعالية`)
};

const ms_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const bn_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন`)
};

const zh_tw2_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事`)
};

const zh_hk2_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事`)
};

const ur_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ`)
};

const fa_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رویداد`)
};

const sw_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukio`)
};

const nl_event = /** @type {(inputs: EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {EventInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event = /** @type {((inputs?: EventInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EventInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event(inputs)
	if (locale === "ja") return ja_event(inputs)
	if (locale === "zh") return zh_event(inputs)
	if (locale === "es") return es_event(inputs)
	if (locale === "pt") return pt_event(inputs)
	if (locale === "id") return id_event(inputs)
	if (locale === "fr") return fr_event(inputs)
	if (locale === "tl") return tl_event(inputs)
	if (locale === "vi") return vi_event(inputs)
	if (locale === "ko") return ko_event(inputs)
	if (locale === "de") return de_event(inputs)
	if (locale === "ru") return ru_event(inputs)
	if (locale === "tr") return tr_event(inputs)
	if (locale === "it") return it_event(inputs)
	if (locale === "pl") return pl_event(inputs)
	if (locale === "uk") return uk_event(inputs)
	if (locale === "hi") return hi_event(inputs)
	if (locale === "ar") return ar_event(inputs)
	if (locale === "ms") return ms_event(inputs)
	if (locale === "bn") return bn_event(inputs)
	if (locale === "zh-TW") return zh_tw2_event(inputs)
	if (locale === "zh-HK") return zh_hk2_event(inputs)
	if (locale === "ur") return ur_event(inputs)
	if (locale === "fa") return fa_event(inputs)
	if (locale === "sw") return sw_event(inputs)
	if (locale === "nl") return nl_event(inputs)
	return en_event(inputs)
});